import { format } from "date-fns";
import avatar from "../../../assets/images/avatar.webp";
import { MoreVertical } from "lucide-react";
import Tooltip from "../../../utils/Tooltip";
import { capitalizeWords } from "../../../components/Reusable/capitalizeWords";

import {
  truncateEmployeeName,
  truncateEmail,
} from "../../../utils/employeeUtils";

const EmployeeTableRow = ({
  user,
  selectedEmployeeIds,
  selectedCheckboxId,
  activeId,
  handleCheckboxChange,
  moveToEmployeeDetails,
  handleShowLeaveLogButton,
  handleShowLeaveLog,
  setEmployeeInformationId,
}) => {


  return (
    <tr>
      <td>
        <input
          type="checkbox"
          name="em_checkbox"
          id={`em_checkbox_${user.id}`}
          onChange={() => handleCheckboxChange(user.employee_information_id)}
          checked={selectedEmployeeIds.includes(user.employee_information_id)}
          disabled={
            selectedCheckboxId &&
            selectedCheckboxId !== user.employee_information_id
          }
        />
      </td>

      <td>{user?.serialNumber}</td>

      <td
        style={{ cursor: "pointer" }}
        onClick={() => moveToEmployeeDetails(user?.employee_information_id)}
      >
        {user?.employee_id}
      </td>

      <td>
        <img
          src={user?.profile_picture || avatar}
          alt="Profile"
        />
      </td>

      <td>
        <Tooltip text={capitalizeWords(user?.employee_full_name)}>
          <div
            className="cursor-pointer"
            onClick={() => moveToEmployeeDetails(user?.employee_information_id)}
          >
            {capitalizeWords(truncateEmployeeName(user?.employee_full_name))}
          </div>
        </Tooltip>

        <div className="text-xs font-medium text-muted">
          {capitalizeWords(user?.roles[0]?.role_name)}
        </div>
      </td>

      <td>{user?.personal_phone_number}</td>

      <td>
        <Tooltip text={user?.official_email}>
          {truncateEmail(user?.official_email)}
        </Tooltip>
      </td>

      <td>{format(new Date(user.updated_at), "dd-MM-yyyy")}</td>

      <td className={user?.is_active ? "active" : "inactive"}>
        {user?.is_active ? "Active" : "In Active"}
      </td>

      <td className="relative">
        {user?.is_active === 1 && (
          <button
            onClick={() =>
              handleShowLeaveLogButton(user.employee_information_id)
            }
          >
            <MoreVertical size={28} />
          </button>
        )}

        <div className="absolute top-11 right-5">
          {activeId === user.employee_information_id && (
            <ul className="flex flex-col rounded-md border bg-white z-50 !gap-0">
              <li className="border-b py-1 hover:bg-neutral-600 hover:text-white">
                <button
                  onClick={() => {
                    handleShowLeaveLog();

                    setEmployeeInformationId({
                      id: user.employee_information_id,
                      name: user.employee_full_name,
                      employeeId: user.employee_id,
                    });
                  }}
                  className="px-4 py-1.5 whitespace-nowrap"
                >
                  Leave Log
                </button>
              </li>

              <li className="py-1 hover:bg-neutral-600 hover:text-white">
                <button className="px-4 py-1.5 whitespace-nowrap">Download Leave</button>
              </li>
            </ul>
          )}
        </div>
      </td>
    </tr>
  );
};

export default EmployeeTableRow;
